import * as Yup from 'yup';

export const initialDripFeederValues = {
  name: 'New Drip Feeder Set',
  sources: null,
  roleId: '',
  rank: 0,
  maxPulls: 0,
  minutesBetweenPulls: 0,
  pullNewestFirst: false,
  useSourceWithLowestCountFirst: false,
  isFronterSet: false,
};

export const dripFeederValidationSchema = Yup.object().shape({
  rank: Yup.string().required(),
  name: Yup.string().required(),
  sources: Yup.array().nullable(),
  roleId: Yup.string().nullable(),
  maxPulls: Yup.number(),
  minutesBetweenPulls: Yup.number(),
  pullNewestFirst: Yup.boolean(),
  useSourceWithLowestCountFirst: Yup.boolean(),
  isFronterSet: Yup.boolean(),
});
